<template>
    <div>
        <v-dialog v-model="dialogShow" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('page.series.edit-source-races') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-row v-if="sourceRacesList.length > 0">
                        <v-col cols="12" v-for="(race,i) in sourceRacesList" :key="`raceSource-${i}`" class="text-left">
                            <span>{{ race.eventName }} - {{ race.raceName }}</span>
                            <v-icon @click="confirmDelete(race)" class="float-right" medium>mdi-delete</v-icon>
                        </v-col>
                    </v-row>
                    <v-row v-else>
                        <v-col>{{ $t('page.series.no-source-races') }}</v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        small dark
                        @click="dialogShow = false"
                    >{{ $t('common.close') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <SGSNotificationConfirm 
            v-if="dialogDeleteSourceRace" 
            :notificationMessage="msgAlert"
            @cancel="dialogDeleteSourceRace=false;" 
            @agree="deleteSourceRace" 
            type='warning' 
            :acept="$t('common.form.delete')"
            :reject="$t('common.form.cancel')" 
        />
    </div>
</template>

<script>
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from "vuex";

export default {
    mixins: [apiCalls],
    components: {
        SGSNotificationConfirm
    },
    props: {
        dialog: { typeof: Boolean, default: false },
        raceItem: { type: Object, default: null },
        isShowError: { type: Boolean, default: false }
    },
    data() {
        return {
            dialogDeleteSourceRace: false,
            sourceRaceId: 0,
            sourceRaceToDelete: null,
            bError: false,
            sourceRaceIdDelete: [],
            isProcess: false
        };
    },
    computed: {
        ...mapState({
            seriesSelected: state => state.series.seriesSelected
        }),
        dialogShow: {
            get() {
                return this.dialog;
            },
            set(newValue) {
                return this.$emit('updateDialog',newValue);
            }
        },
        sourceRacesList() {
            const { racesSourceList } = this.raceItem ?? {};
            let racesSource = [];
            try {
                racesSource = JSON.parse(racesSourceList);
            } catch {/***/}
            return racesSource.filter((race) => !this.sourceRaceIdDelete.includes(race.raceId));
        },
        msgAlert() {
            if (this.sourceRaceToDelete && this.sourceRaceToDelete.eventName != null && this.sourceRaceToDelete.raceName != null) {
                return this.$t('page.series.confirm-delete-race', {
                    eventName: this.sourceRaceToDelete.eventName,
                    raceName: this.sourceRaceToDelete.raceName
                });
            }
            return this.$t('common.confirm-delete');
        }
    },
    methods: {
        confirmDelete(item) {
            this.sourceRaceId = item.raceId;
            this.sourceRaceToDelete = { eventName: item.eventName, raceName: item.raceName };
            this.dialogShow = false;
            this.dialogDeleteSourceRace = true;
        },
        async deleteSourceRace() {
            this.dialogDeleteSourceRace = false;
            this.isProcess = true;
            const { sourceRaceId } = this;
            const { raceId } = this.raceItem;
            const { id: seriesId } = this.seriesSelected;
            const response = await this.deleteApi(`/api/v1/promoter/series/table/race/sourceRace/${seriesId}/${raceId}/${sourceRaceId}`);
            
            if(response && response.success){
                this.sourceRaceIdDelete.push(sourceRaceId);
                this.$emit('refreshRaces');
                this.dialogShow = true;
            } else {
                this.bError = true;
                this.$emit('showError',{ display: true, msg: this.$t('common.failed-save') });
            }
            this.isProcess = false;
        },
        reset() {
            this.sourceRaceIdDelete = [];
            this.sourceRaceToDelete = null;
            this.bError = false;
        }
    },
    watch: {
        dialogDeleteSourceRace(val) {
            if(!val && !this.bError && !this.isProcess) {
                this.dialogShow = true;
            }
        },
        isShowError(val) {
            if(!val && this.bError) {
                this.bError = false;
                this.dialogDeleteSourceRace = true;
            }
        }
    }
};
</script>